import request from '@/api/config.js'

/** Список интеграций организации. В Network отображается как integrations-list. */
export function getOrgIntegrations(orgId) {
  return request({
    url: `integrations/org/${orgId}/integrations-list`,
    method: 'get',
  })
}

export function toggleOrgIntegration(orgId, integId) {
  return request({
    url: `integrations/org/${orgId}/${integId}/toggle`,
    method: 'post',
  })
}

export function getIntegrationValues(orgId, integId) {
  return request({
    url: `integrations/org/${orgId}/${integId}/values`,
    method: 'get',
  })
}

export function saveIntegrationValues(orgId, integId, values) {
  return request({
    url: `integrations/org/${orgId}/${integId}/values`,
    method: 'put',
    data: values,
  })
}
